import React from "react";
import { Box, Typography, useTheme, alpha } from "@mui/material";
import { Explore as ExploreIcon } from "@mui/icons-material";

export const DiscoverHeader: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            bgcolor: alpha(theme.palette.secondary.main, 0.1),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ExploreIcon sx={{ color: "secondary.main", fontSize: 28 }} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Discover Circles
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Browse public circles and request to join
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

